import styled from 'styled-components';
import {
  lg_mobile_breakpoint,
  desktop_breakpoint,
  tablet_landscape_breakpoint,
  desktop_container_maxwidth_compact,
  sm_desktop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const HomeDetailsStyles = styled.div`
  padding-top: 25px;
  min-height: 550px;

  > div .disclaimer-content {
    width: 100%;
  }

  .learn-more-container,
  .find-retailer-container {
    background-color: ${Colors.secondary.grey6.standard};
  }

  .request-form {
    .modal-component {
      .modal-container {
        width: 95%;
        max-width: 512px;
        z-index: 99999;
      }
    }
  }

  .card-image-single img {
    transform: translateX(0px);
  }

  .home-details-prefooter {
    > div {
      margin-top: 0;
    }
    .cta-container {
      margin: 0 auto;

      .cta-position-fullwidth {
        padding-bottom: 0;
        .cta {
          border-radius: 0;
          margin: 0 auto;
          min-height: 378px;
          .cta-inside {
            width: 95%;
            .cta-heading {
              font-size: 26px;
              line-height: 31px;
            }
            .cta-buttons {
              margin-top: 35px;
            }
          }
        }
      }
    }
  }

  .map-section {
    margin-top: 72px;

    p {
      margin-bottom: 16px;
    }

    #map {
      height: 224px;
    }
  }

  .constrained-width {
    width: 88%;
  }

  @media only screen and (min-width: ${lg_mobile_breakpoint}px) {
    .home-details-prefooter {
      .cta-container {
        .cta-position-fullwidth {
          .cta {
            .cta-inside {
              padding: 120px 0 30px 0;
            }
          }
        }
      }
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .images-titles-section {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: 1fr;
      gap: 36px;
      width: 100%;

      .titles-section {
        grid-area: 1 / 3 / 2 / 4;
      }
    }
    .constrained-width {
      max-width: ${desktop_container_maxwidth_compact}px;

      .image-gallery-grid {
        grid-area: 1 / 1 / 2 / 3;

        .modal-container {
          width: 100%;
          max-width: 100%;
        }
      }
      .titles {
        width: 40%;
      }
    }

    .map-section {
      margin-top: 96px;

      h2 {
        margin-bottom: 16px;
      }

      #map {
        height: 496px;
      }
    }

    .featured-homes-section {
      margin: 96px 0 48px;
    }
    .home-details-prefooter {
      margin: 48px 0 0;

      .cta-container {
        .cta-position-fullwidth {
          .cta {
            min-height: 418px;
            .cta-inside {
              max-width: 96%;
              .cta-heading {
                font-size: 32px;
                line-height: 38px;
              }
              .cta-buttons {
                margin-top: 48px;
              }
            }
          }
        }
      }
    }
  }

  @media only screen and (min-width: ${tablet_landscape_breakpoint}px) {
    .titles-section {
      min-width: 380px;
    }
  }

  @media only screen and (min-width: ${sm_desktop_breakpoint}px) {
    .home-details-prefooter {
      .cta-container {
        .cta-position-fullwidth {
          .cta {
            .cta-inside {
              padding: 160px 0 0 0;
            }
          }
        }
      }
    }
  }
`;

export default HomeDetailsStyles;
